import React from 'react';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { Modal, Button, Form, Spinner, Toast, ToastContainer } from 'react-bootstrap';
import { useCancelamento } from '../../hooks/useCancelamento';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


const CancelamentoObs = () => {

    const {
        contatoCliente,
        setContatoCliente,
        nomeCliente,
        setNomeCliente,
        porOnde,
        setPorOnde,
        motivoCancelamento,
        setMotivoCancelamento,
        linkChat,
        setLinkChat,
        handleSubmit,
        navigate,
        mensagemFinal,
        handleSendToAdm,
        showModal,
        setShowModal,
        isAgendar,
        handleAgendarSwitch,
        selectedDate,
        handleDateChange,
        options,
        responsavel,
        onInputChange,
        setResponsavel,
        handleFocus,
        handleEnviarObs,
        isLoading,
        setShowToastError,
        setShowToastSuccess,
        showToastError,
        showToastSuccess,
        showToastCopiar,
        setShowToastCopiar,
        labelBtnCopy,
        setLabelBtnCopy
    } = useCancelamento();


    return (
        <div className="container-data">
            <h1>Solicitação de Cancelamento</h1>
            <form className='form-cancelamento'>
                <div className="form-group">
                    <label className='label-mensagem'>Contato do cliente:</label>
                    <textarea
                        value={contatoCliente}
                        onChange={(e) => setContatoCliente(e.target.value)}
                        placeholder="Digite o contato do cliente"
                        className="textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Nome do cliente:</label>
                    <textarea
                        value={nomeCliente}
                        onChange={(e) => setNomeCliente(e.target.value)}
                        placeholder="Digite o nome do cliente"
                        className="textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Por onde?</label>
                    <textarea
                        value={porOnde}
                        onChange={(e) => setPorOnde(e.target.value)}
                        placeholder="Descreva por onde o cliente solicitou"
                        className="textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Motivo da solicitação:</label>
                    <textarea
                        value={motivoCancelamento}
                        onChange={(e) => {
                            setMotivoCancelamento(e.target.value)
                            e.target.style.height = 'auto';
                            e.target.style.height = `${e.target.scrollHeight}px`
                        }}
                        placeholder="Descreva o motivo da solicitação"
                        className="textarea auto-resize-textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Link do chat:</label>
                    <textarea
                        value={linkChat}
                        onChange={(e) => setLinkChat(e.target.value)}
                        placeholder="Insira o link do chat:"
                        className="textarea"
                    />
                </div>
            </form>
            
            <div className='options-gerar-mensagem'>
                <button onClick={() => navigate('/treinamento')} className="botaovoltar">
                    <FontAwesomeIcon icon={faArrowLeft} className='arrow-left-icon' />
                    Voltar
                </button>
                <button onClick={handleSubmit} className="botao-pesquisa">Gerar</button>
            </div>

            {mensagemFinal && (<>
                <div className='div-mensagem-cancelamento'>
                    <div className="mensagem-gerada">
                        <h2>Mensagem Gerada:</h2>
                        <pre className='mensagem-cancelamento'>{mensagemFinal}</pre>
                    </div>             
                </div>
            <div className='options-mensagem-cancelamento'>
                        <button className="post-button" onClick={handleSendToAdm}>Enviar ao ADM</button>
                        <button 
                        className="post-button" 
                        onClick={() => {
                        navigator.clipboard.writeText(mensagemFinal);
                        setShowToastCopiar(true);
                        setLabelBtnCopy('Copiado!');
                        setTimeout(() => {
                            setLabelBtnCopy('Copiar')
                        }, 3000);
                        }}
                        >
                        {labelBtnCopy}
                        </button>
                    </div>
                    </>
            )}

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Enviar ao ADM</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>Mensagem:</h4>
                    <pre>{mensagemFinal}</pre>

                    <Form.Group className="mt-3">
                        <Form.Check
                            type="switch"
                            id="agendar-switch"
                            label="Agendar"
                            checked={isAgendar}
                            onChange={handleAgendarSwitch}
                        />
                    </Form.Group>

                    {isAgendar && (
                        <div>
                            <div className="mt-3">
                                <label>Data e Hora:</label>
                                <br />
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={handleDateChange}
                                    showTimeSelect
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy, HH:mm"
                                />
                            </div>
                            <div className="mt-3">
                                <label>Responsável</label>
                                <Select
                                    options={options}
                                    value={responsavel}
                                    onInputChange={onInputChange}
                                    onChange={(selected) => {
                                        setResponsavel(selected);
                                        console.log('Responsável selecionado:', selected);
                                    }}
                                    onFocus={handleFocus} 
                                />
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                <Button variant="danger" onClick={() => setShowModal(false)}>
                    Fechar
                </Button>
                <Button variant="success" onClick={handleEnviarObs} disabled={isLoading}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : "Enviar"}
                </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer position="bottom-end" className="p-3">
                <Toast 
                    onClose={() => setShowToastSuccess(false)} 
                    show={showToastSuccess} 
                    delay={3000} 
                    autohide 
                    bg="success"
                >
                    <Toast.Header>
                        <strong className="me-auto">Sucesso</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">Observação enviada com sucesso!</Toast.Body>
                </Toast>

                <Toast 
                    onClose={() => setShowToastCopiar(false)} 
                    show={showToastCopiar} 
                    delay={3000} 
                    autohide 
                    bg="success"
                >
                    <Toast.Header>
                        <strong className="me-auto">Sucesso</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">Observação copiada com sucesso!</Toast.Body>
                </Toast>

                <Toast 
                    onClose={() => setShowToastError(false)} 
                    show={showToastError} 
                    delay={3000} 
                    autohide 
                    bg="danger"
                >
                    <Toast.Header>
                        <strong className="me-auto">Erro</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">Erro ao enviar a observação.</Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    );
};

export default CancelamentoObs;
